import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled('tr')`
  border-bottom: 1px solid #dee2e6;
  height: 48px;
  color: #72747b;
  td {
    color: #72747b;
  }
`;

const TableRow = (props) => {
  const { item } = props;

  return (
    <>
      <Wrapper>
        <td colSpan="3">Материалы упаковочные (скотч, гофрокороб, прочие)</td>
        <td className="right bolder">14.4₽</td>
        <td>ед. товара</td>
      </Wrapper>
    </>
  );
};

export default TableRow;
